import React from 'react'

function RentalRequest() {
  return (
    <div>   <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.07669 15.9976C7.05136 15.9976 7.03084 16.0182 7.03084 16.0435C7.03084 16.0688 7.05136 16.0893 7.07669 16.0893C7.10201 16.0893 7.12254 16.0688 7.12254 16.0435C7.12254 16.0182 7.10201 15.9976 7.07669 15.9976"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.83457 15.9976C4.82249 15.9976 4.81092 16.0025 4.80246 16.0111C4.79401 16.0197 4.78938 16.0314 4.78963 16.0435C4.78963 16.0688 4.81016 16.0893 4.83548 16.0893C4.86081 16.0893 4.88133 16.0688 4.88133 16.0435C4.88133 16.0182 4.86081 15.9976 4.83548 15.9976"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="5.95582"
      cy="16.0437"
      r="4.12672"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.00148 12.4082C2.93369 8.78141 4.46194 4.89235 7.71315 2.96279C10.9644 1.03323 15.1102 1.55476 17.7823 4.22942C20.4543 6.90409 20.9718 11.0505 19.039 14.2998C17.1062 17.5491 13.2157 19.0735 9.58997 18.0022"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.4848 10.4409H11.458V5.49707"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default RentalRequest